import { action, computed, observable, makeObservable } from 'mobx';

export class ChatStore {
  @observable isAutoScrollDisabled = false;
  @observable scrollChanged = null;
  @observable isShowSearch = false;
  @observable isShowSidebar = false;

  scrollOptions = {};

  constructor(root) {
    makeObservable(this);
    this.root = root;
  }

  @computed
  get isDisableToWrite() {
    const group = this.root.GroupsStore.activeGroup;
    if (!group) {
      return true;
    }

    if (group.isChatGroup) {
      return group.withoutMe;
    }
    if (group.isChannel) {
      return !group.withMeInAdmins;
    }

    return false;
  }

  @computed
  get isOnlyLeftSideMessages() {
    return this.root.App.width > 1440;
  }

  @action
  showSearch = () => {
    this.hideSidebar();
    this.isShowSearch = true;
  };

  @action
  hideSearch = () => {
    this.isShowSearch = false;
  };

  @action
  toggleSidebar() {
    this.isShowSidebar ? this.hideSidebar() : this.showSidebar();
  }

  @action
  showSidebar = () => {
    this.hideSearch();
    this.isShowSidebar = true;
  };

  @action
  hideSidebar = () => {
    this.isShowSidebar = false;
  };

  @action
  setScrollChanged(value, options) {
    this.scrollChanged = value;
    this.scrollOptions = options || {};
  }

  @action
  setAutoScrollDisabled = (isDisabled) => {
    this.isAutoScrollDisabled = isDisabled;
  };

  @action
  reset = () => {
    this.hideSearch();
    this.hideSidebar();
  };
}
